// extracted by mini-css-extract-plugin
export default {"executiveInformation":"ExecutiveInformation_executiveInformation__Ye5+0","table":"ExecutiveInformation_table__Xy5p-"};